import { styled } from 'styled-components';

export const MainWrapper = styled.div`
  padding-bottom: 100px;
  position: relative;
`;
